module.exports = __webpack_public_path__ + "static/media/Lock.b6785386.svg";